import gql from 'graphql-tag'

export const GET_USERS_LIST = gql`
  query usersManagement($waveIds: [String], $text: String, $labId: String!, $accountIds: [String]) {
    coordinator(accountIds: $accountIds) {
      user {
        list(filter: { waveIds: $waveIds, text: $text, labId: $labId }) {
          id
          lastName
          firstName
          email
          quartile
          status
          storyCount
          activity {
            firstLogIn
            created
          }
          wave {
            name
          }
          progress {
            startDate
            currentStep
            daysPerStep
            paceProgress
          }
        }
      }
    }
  }
`
